// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2MEYb","noInteraction":"EventWrapper_noInteraction__26XFQ"};